const backendApiUrl = process.env.REACT_APP_URL_FOR_API;

const fallbackBackendApiUrl = "http://0.0.0.0:8080";

export const REACT_APP_BACKEND_API_URL =
  backendApiUrl !== undefined ? backendApiUrl : fallbackBackendApiUrl;
